<template>
    <Popup v-show="isShown" @hide="onClose">
        <div class="px-3 pt-2">
            List of items that were not duplicated.
        </div>
        <ol class="pl-5">
            <li v-for="item in items" :key="item.item_id">
                <router-link
                    v-if="item.encoded_item_id"
                    target="_blank"
                    :to="{ name: 'item', params: { id: item.encoded_item_id } }"
                    >{{ item.item_name }}</router-link
                >
                <a v-else class="text-link">{{ item.item_name }}</a>
            </li>
        </ol>
    </Popup>
</template>

<script>
export default {
    components: {
        Popup: () => import("@/components/elements/popup")
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isShown: false
        };
    },
    mounted() {
        if (this.items.length > 0) {
            this.isShown = true;
        }
    },
    methods: {
        onClose() {
            this.isShown = false;
        }
    }
};
</script>
